import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { PASSIVE_REQUEST } from './http-request-context';

const REFRESH_THRESHOLD_MS = 3 * 60 * 1000;

function isAuthFlowRequest(url: string): boolean {
  return url.includes('/auth/login') || url.includes('/auth/register') || url.includes('/auth/verify-email') || url.includes('/auth/refresh') || url.includes('/auth/logout');
}

export function JwtInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const token = authService.getToken();
  const passiveRequest = req.context.get(PASSIVE_REQUEST);

  const forwardRequest = (activeToken: string | null): Observable<HttpEvent<unknown>> => {
    if (activeToken) {
      const cloned = req.clone({
        setHeaders: {
          Authorization: `Bearer ${activeToken}`,
        },
      });
      return next(cloned);
    }

    return next(req);
  };

  if (!token) {
    return next(req);
  }

  if (!passiveRequest && !isAuthFlowRequest(req.url) && authService.shouldRefreshWithin(REFRESH_THRESHOLD_MS)) {
    return authService.refreshAccessToken().pipe(
      switchMap((response) => forwardRequest(response?.accessToken ?? authService.getToken()))
    );
  }

  return forwardRequest(token);
}
